"use strict";
module.exports = function load(templatePath) {
    throw Error("Not found: " + templatePath);
};
